import axios from "axios";

export default {
    async CheckTaxNumber(data) {
        const response = await axios.get(`/api/firmoperations/firm/check/taxnumber/${data}`);
        return response;
    },
    async List(prefix, isOwnFirm = null) {
        const response = await axios.get(isOwnFirm != null ? `/api/firmoperations/firm/select/list/${prefix}/${isOwnFirm}` : `/api/firmoperations/firm/select/list/${prefix}`);
        return response;
    },
    async ListByFirmRole(firmRole) {
        const response = await axios.get(`/api/firmoperations/firm/select/listbyrole/${firmRole}`);
        return response;
    },
    async Create(data) {
        const response = await axios.post(`/api/firmoperations/firm/create`, data);
        return response;
    },
    async Table(data) {
        const response = await axios.post(`/api/firmoperations/firm/table`, data);
        return response;
    },
    async ListAll() {
        const response = await axios.get(`/api/firmoperations/firm/select/listall`);
        return response;
    },
    async DataTable(data) {
        const response = await axios.post(`/api/firmoperations/firm/datatable`, data);
        return response;
    },
    async Get(id) {
        const response = await axios.get(`/api/firmoperations/firm/get/${id}`);
        return response;
    },
    async InfoUpdate(data) {
        const response = await axios.post(`/api/firmoperations/firm/update`, data);
        return response;
    },
    async Delete(id) {
        const response = await axios.post(`/api/firmoperations/firm/delete/${id}`);
        return response;
    },
    ParentFirm: {
        async CreateOrUpdate(update, data) {
            const response = await axios.post(update ? `/api/firmoperations/parentfirm/update` : `/api/firmoperations/parentfirm/create`, data);
            return response;
        },
        async Get(id) {
            const response = await axios.get(`/api/firmoperations/parentfirm/get/${id}`);
            return response;
        },
        async Delete(id) {
            const response = await axios.post(`/api/firmoperations/parentfirm/delete/${id}`);
            return response;
        },
        async List() {
            const response = await axios.get(`/api/firmoperations/parentfirm/list/select`);
            return response;
        },
        async Table(data) {
            const response = await axios.post(`/api/firmoperations/parentfirm/table`, data);
            return response;
        },
    },
    Location: {
        async Table(data) {
            const response = await axios.post(`/api/firmoperations/firmlocation/table`, data);
            return response;
        },
        async Get(id) {
            const response = await axios.get(`/api/firmoperations/firmlocation/get/${id}`);
            return response;
        },
        async CreateOrUpdate(update, data) {
            const response = await axios.post(update ? `/api/firmoperations/firmlocation/update` : `/api/firmoperations/firmlocation/create`, data);
            return response;
        },
        async Delete(id) {
            const response = await axios.post(`/api/firmoperations/firmlocation/delete/${id}`);
            return response;
        },
        async List(id) {
            const response = await axios.get(`/api/firmoperations/firmlocation/select/list/${id}`);
            return response;
        },
    },
    Contact: {
        async Table(data) {
            const response = await axios.post(`/api/firmoperations/firmcontact/table`, data);
            return response;
        },
        async Get(id) {
            const response = axios.get(`/api/firmoperations/firmcontact/get/${id}`);
            return response;
        },
        async CreateOrUpdate(update, data) {
            const response = await axios.post(update ? `/api/firmoperations/firmcontact/update` : `/api/firmoperations/firmcontact/create`, data);
            return response;
        },
        async Delete(id) {
            const response = await axios.post(`/api/firmoperations/firmcontact/delete/${id}`);
            return response;
        },
    },
};
